<form
  [formGroup]="report_form_group"
  class="sp-column sp-form__standalone sp-padding__x4">
  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'SHARED.TOOLBAR_REPORT_LABEL' | translate }}
    </mat-label>
    <mat-select
      formControlName="report_type"
      [errorStateMatcher]="error_matcher"
      required
      (selectionChange)="onReportTypeChange()">
      <mat-option [value]="company">{{ 'SHARED.TOOLBAR_COMPANIES_LABEL' | translate }}</mat-option>
      <mat-option [value]="unpaid">{{ 'SHARED.TOOLBAR_UNPAID_LABEL' | translate }}</mat-option>
      <mat-option [value]="store">{{ 'SHARED.TOOLBAR_STORES_LABEL' | translate }}</mat-option>
      <mat-option [value]="order">{{ 'SHARED.TOOLBAR_ORDERS_LABEL' | translate }}</mat-option>
      <mat-option [value]="seller">{{ 'SHARED.TOOLBAR_SELLERS_LABEL' | translate }}</mat-option>
      <mat-option [value]="buyer">{{ 'SHARED.TOOLBAR_BUYERS_LABEL' | translate }}</mat-option>
      <mat-option [value]="vop_request">{{ 'SHARED.TOOLBAR_VOP_REQUEST_LABEL' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <ng-container *ngIf="report_form_group.get('report_type')?.value === company">
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</mat-label>
      <mat-select formControlName="status">
        <mat-option value="">{{ 'COMPANIES.SUMMARY_ALL_LABEL' | translate }}</mat-option>
        <mat-option value="pending_evaluation">{{ 'COMPANIES.SUMMARY_NO_CONTRACT_LABEL' | translate }}</mat-option>
        <mat-option value="pending_signature">{{ 'COMPANIES.SUMMARY_PENDING_SIGNATURE_LABEL' | translate }}</mat-option>
        <mat-option value="pending_acceptance">{{
          'COMPANIES.SUMMARY_PENDING_EVALUATION_LABEL' | translate
        }}</mat-option>
        <mat-option value="accepted">{{ 'COMPANIES.ACCEPTED_LABEL' | translate }}</mat-option>
        <mat-option value="denied">{{ 'COMPANIES.DENIED_LABEL' | translate }}</mat-option>
        <mat-option value="archived">{{ 'COMPANIES.ARCHIVED_LABEL' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'GENERAL.AGREEMENT_LABEL' | translate }}</mat-label>
      <mat-select
        formControlName="agreement"
        [errorStateMatcher]="error_matcher">
        <mat-option
          *ngFor="let agreement of company_agreement_list"
          [value]="agreement">
          {{ agreement }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'COMPANIES.PRODUCT_CATEGORY' | translate }}</mat-label>
      <mat-select formControlName="product_category">
        <mat-option value="">{{ 'COMPANIES.SUMMARY_ALL_LABEL' | translate }}</mat-option>
        <mat-option value="clothing">{{ 'COMPANIES.PRODUCT_CATEGORY_CLOTHING' | translate }}</mat-option>
        <mat-option value="real_estate_agencies">{{
          'COMPANIES.PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES' | translate
        }}</mat-option>
        <mat-option value="hearing_aids">{{ 'COMPANIES.PRODUCT_CATEGORY_HEARING_AIDS' | translate }}</mat-option>
        <mat-option value="furniture">{{ 'COMPANIES.PRODUCT_CATEGORY_FURNITURE' | translate }}</mat-option>
        <mat-option value="home_and_bathroom_furniture">{{
          'COMPANIES.PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE' | translate
        }}</mat-option>
        <mat-option value="musical_instruments">{{
          'COMPANIES.PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS' | translate
        }}</mat-option>
        <mat-option value="sporting_goods">{{ 'COMPANIES.PRODUCT_CATEGORY_SPORTING_GOODS' | translate }}</mat-option>
        <mat-option value="insurance">{{ 'COMPANIES.PRODUCT_CATEGORY_INSURANCE' | translate }}</mat-option>
        <mat-option value="bicycles">{{ 'COMPANIES.PRODUCT_CATEGORY_BICYCLES' | translate }}</mat-option>
        <mat-option value="bodywork">{{ 'COMPANIES.PRODUCT_CATEGORY_BODYWORK' | translate }}</mat-option>
        <mat-option value="furniture_accessories">{{
          'COMPANIES.PRODUCT_CATEGORY_FURNITURE_ACCESSORIES' | translate
        }}</mat-option>
        <mat-option value="dealers">{{ 'COMPANIES.PRODUCT_CATEGORY_DEALERS' | translate }}</mat-option>
        <mat-option value="cosmetics_beauty">{{
          'COMPANIES.PRODUCT_CATEGORY_COSMETICS_BEAUTY' | translate
        }}</mat-option>
        <mat-option value="door_to_door">{{ 'COMPANIES.PRODUCT_CATEGORY_DOOR_TO_DOOR' | translate }}</mat-option>
        <mat-option value="diy_and_home_improvement">{{
          'COMPANIES.PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT' | translate
        }}</mat-option>
        <mat-option value="physiotherapy_osteopathy">{{
          'COMPANIES.PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY' | translate
        }}</mat-option>
        <mat-option value="training_and_courses">{{
          'COMPANIES.PRODUCT_CATEGORY_TRAINING_AND_COURSES' | translate
        }}</mat-option>
        <mat-option value="tire_dealers">{{ 'COMPANIES.PRODUCT_CATEGORY_TIRE_DEALERS' | translate }}</mat-option>
        <mat-option value="home_alarm_systems">{{
          'COMPANIES.PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS' | translate
        }}</mat-option>
        <mat-option value="car_alarm_systems">{{
          'COMPANIES.PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS' | translate
        }}</mat-option>
        <mat-option value="car_motorcycle_repair_shops">{{
          'COMPANIES.PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS' | translate
        }}</mat-option>
        <mat-option value="opticians">{{ 'COMPANIES.PRODUCT_CATEGORY_OPTICIANS' | translate }}</mat-option>
        <mat-option value="gyms">{{ 'COMPANIES.PRODUCT_CATEGORY_GYMS' | translate }}</mat-option>
        <mat-option value="bed_bases_and_mattresses">{{
          'COMPANIES.PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES' | translate
        }}</mat-option>
        <mat-option value="energy_renovation">{{
          'COMPANIES.PRODUCT_CATEGORY_ENERGY_RENOVATION' | translate
        }}</mat-option>
        <mat-option value="doors_and_windows">{{
          'COMPANIES.PRODUCT_CATEGORY_DOORS_AND_WINDOWS' | translate
        }}</mat-option>
        <mat-option value="professional_services">{{
          'COMPANIES.PRODUCT_CATEGORY_PROFESSIONAL_SERVICES' | translate
        }}</mat-option>
        <mat-option value="dental_clinics">{{ 'COMPANIES.PRODUCT_CATEGORY_DENTAL_CLINICS' | translate }}</mat-option>
        <mat-option value="medical_practices">{{
          'COMPANIES.PRODUCT_CATEGORY_MEDICAL_PRACTICES' | translate
        }}</mat-option>
        <mat-option value="veterinarians">{{ 'COMPANIES.PRODUCT_CATEGORY_VETERINARIANS' | translate }}</mat-option>
        <mat-option value="stoves_and_fireplaces">{{
          'COMPANIES.PRODUCT_CATEGORY_STOVES_AND_FIREPLACES' | translate
        }}</mat-option>
        <mat-option value="leisure">{{ 'COMPANIES.PRODUCT_CATEGORY_LEISURE' | translate }}</mat-option>
        <mat-option value="tv_telephony_and_electronics">{{
          'COMPANIES.PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS' | translate
        }}</mat-option>
        <mat-option value="other">{{ 'GENERAL.OTHER_LABEL' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="report_form_group.get('report_type')?.value === store">
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</mat-label>
      <mat-select formControlName="status">
        <mat-option value="">{{ 'STORES.SUMMARY_ALL_LABEL' | translate }}</mat-option>
        <mat-option value="enabled">{{ 'GENERAL.ENABLED_LABEL' | translate }}</mat-option>
        <mat-option value="disabled">{{ 'GENERAL.DISABLED_LABEL' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.FILTER_CREATED_FROM_LABEL' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="created_from_picker"
        formControlName="created_from" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="created_from_picker"></mat-datepicker-toggle>
      <mat-datepicker #created_from_picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.FILTER_CREATED_TO_LABEL' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="created_to_picker"
        formControlName="created_to" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="created_to_picker"></mat-datepicker-toggle>
      <mat-datepicker #created_to_picker></mat-datepicker>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="report_form_group.get('report_type')?.value === seller">
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</mat-label>
      <mat-select formControlName="status">
        <mat-option value="">{{ 'SELLERS.SUMMARY_ALL_LABEL' | translate }}</mat-option>
        <mat-option value="green">{{ 'SELLERS.CONFIRMED_GREEN_LABEL' | translate }}</mat-option>
        <mat-option value="orange">{{ 'SELLERS.CONFIRMED_ORANGE_LABEL' | translate }}</mat-option>
        <mat-option value="red">{{ 'SELLERS.CONFIRMED_RED_LABEL' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }} ({{ 'REPORT.FROM_LABEL' | translate }})</mat-label>
      <input
        matInput
        [matDatepicker]="reg_from_picker"
        formControlName="created_from" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="reg_from_picker"></mat-datepicker-toggle>
      <mat-datepicker #reg_from_picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }} ({{ 'REPORT.TO_LABEL' | translate }})</mat-label>
      <input
        matInput
        [matDatepicker]="reg_to_picker"
        formControlName="created_to" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="reg_to_picker"></mat-datepicker-toggle>
      <mat-datepicker #reg_to_picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'GENERAL.LAST_LOGIN_LABEL' | translate }} ({{ 'REPORT.FROM_LABEL' | translate }})</mat-label>
      <input
        matInput
        [matDatepicker]="login_from_picker"
        formControlName="last_login_from" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="login_from_picker"></mat-datepicker-toggle>
      <mat-datepicker #login_from_picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'GENERAL.LAST_LOGIN_LABEL' | translate }} ({{ 'REPORT.TO_LABEL' | translate }})</mat-label>
      <input
        matInput
        [matDatepicker]="login_to_picker"
        formControlName="last_login_to" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="login_to_picker"></mat-datepicker-toggle>
      <mat-datepicker #login_to_picker></mat-datepicker>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="report_form_group.get('report_type')?.value === order">
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'STORES.MIN_AMOUNT_LABEL' | translate }}</mat-label>
      <input
        matInput
        type="number"
        formControlName="amount_min" />
    </mat-form-field>
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'STORES.MAX_AMOUNT_LABEL' | translate }}</mat-label>
      <input
        matInput
        type="number"
        formControlName="amount_max" />
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="report_form_group.get('report_type')?.value === buyer">
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'BUYERS.EXCLUDE_GDPR_CTA' | translate }}</mat-label>
      <mat-select formControlName="exclude_gdpr">
        <mat-option value="yes">{{ 'GENERAL.YES_LABEL' | translate }}</mat-option>
        <mat-option value="no">{{ 'GENERAL.NO_LABEL' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'BUYERS.ONBOARDING_COMPLETED_FROM_LABEL' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="onboarding_completed_from_picker"
        formControlName="onboarding_completed_from" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="onboarding_completed_from_picker"></mat-datepicker-toggle>
      <mat-datepicker #onboarding_completed_from_picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'BUYERS.ONBOARDING_COMPLETED_TO_LABEL' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="onboarding_completed_to_picker"
        formControlName="onboarding_completed_to" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="onboarding_completed_to_picker"></mat-datepicker-toggle>
      <mat-datepicker #onboarding_completed_to_picker></mat-datepicker>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="report_form_group.get('report_type')?.value === vop_request">
    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.FILTER_CREATED_FROM_LABEL' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="vop_created_from_picker"
        formControlName="created_from" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="vop_created_from_picker"></mat-datepicker-toggle>
      <mat-datepicker #vop_created_from_picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="sp-width__full sp-margin__bottom-x2 sp-form-field__primary-light"
      appearance="fill"
      color="accent">
      <mat-label>{{ 'ORDERS.FILTER_CREATED_TO_LABEL' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="vop_created_to_picker"
        formControlName="created_to" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="vop_created_to_picker"></mat-datepicker-toggle>
      <mat-datepicker #vop_created_to_picker></mat-datepicker>
    </mat-form-field>
  </ng-container>

  <mat-form-field
    *ngIf="isOrderOrUnpaid()"
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'REPORT.FROM_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      type="text"
      formControlName="from"
      [errorStateMatcher]="error_matcher"
      [matDatepicker]="from_picker" />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="from_picker"></mat-datepicker-toggle>
    <mat-datepicker #from_picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field
    *ngIf="isOrderOrUnpaid()"
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'REPORT.TO_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      type="text"
      formControlName="to"
      [errorStateMatcher]="error_matcher"
      [matDatepicker]="to_picker" />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="to_picker"></mat-datepicker-toggle>
    <mat-datepicker #to_picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'GENERAL.EMAIL_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      type="text"
      formControlName="email"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <app-shared-button
    class="sp-width__full sp-margin__top-x2"
    [button_class]="'sp-button__main'"
    [spinner_class]="'sp-spinner__main'"
    [cta]="'GENERAL.EXPORT_CTA'"
    [icon]="'download'"
    [is_disabled]="!isFormValid() || is_export_running"
    [is_spinner_visible]="is_export_running"
    (click)="onExportClick()"></app-shared-button>
</form>
